export default __webpack_public_path__ + "static/media/program-3-active.267f24bf.png";